import React, { useState, useRef } from 'react';

export default function TagInput({ tags = [], onChange, placeholder = 'Add tag, press Enter' }) {
  const [input, setInput] = useState('');
  const inputRef = useRef(null);

  const add = (val) => {
    const t = val.trim().toLowerCase().replace(/\s+/g, '-');
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setInput('');
  };

  const remove = (t) => onChange(tags.filter(x => x !== t));

  const onKey = (e) => {
    if (['Enter', ',', ' '].includes(e.key)) {
      e.preventDefault();
      if (input.trim()) add(input);
    } else if (e.key === 'Backspace' && !input && tags.length) {
      remove(tags[tags.length - 1]);
    }
  };

  return (
    <div
      className="tag-input-wrapper"
      onClick={() => inputRef.current?.focus()}
    >
      {tags.map(t => (
        <span key={t} className="tag-badge removable" onClick={() => remove(t)}>
          {t} ×
        </span>
      ))}
      <input
        ref={inputRef}
        className="tag-input-field"
        value={input}
        onChange={e => setInput(e.target.value)}
        onKeyDown={onKey}
        onBlur={() => { if (input.trim()) add(input); }}
        placeholder={tags.length === 0 ? placeholder : ''}
      />
    </div>
  );
}